"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Logout;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Logout(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "logout"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline-4",
    "data-name": "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M79.2,76.517a37.5,37.5,0,1,1,0-53.034,2.5,2.5,0,0,0,3.535-3.535,42.5,42.5,0,0,0-60.1,60.1,42.5,42.5,0,0,0,60.1,0A2.5,2.5,0,0,0,79.2,76.517Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M88.97,47.963,71.894,30.886a2.5,2.5,0,0,0-3.536,3.535l13.3,13.3H37.687a2.5,2.5,0,0,0,0,5H81.22L68.357,65.579a2.5,2.5,0,1,0,3.536,3.535L88.97,52.038A2.884,2.884,0,0,0,88.97,47.963Z"
  })))));
}